import React, { Component, Fragment } from 'react';
import { arrayOf, oneOfType, node, shape, string } from 'prop-types';
import { useStyle } from '@magento/venia-ui/lib/classify';
import { BasicRadioGroup, asField } from 'informed';
import { compose } from 'redux';

import classify from '@magento/venia-ui/lib/classify';
import { Message } from '../../components/Field';
import Radio from './radio';
import defaultClasses from './radioGroup.module.css';

export class RadioGroup extends Component {
    static propTypes = {
        classes: shape({
            message: string,
            radio: string,
            radioLabel: string,
            root: string
        }),
        fieldState: shape({
            value: string
        }),
        items: arrayOf(
            shape({
                label: oneOfType([string, node]),
                value: string
            })
        ),
        message: node
    };

    render() {
        const {
            fieldState,
            items,
            message,
            disabled = false,
            radioGroupName,
            ...rest
        } = this.props;

        const classes = useStyle(defaultClasses, this.props.classes);

        //        const key = `${radioGroupName} ${item.code}`;

        const options = items.map(
            ({
                code,
                label,
                value,
                thumb,
                image,
                price,
                price_by,
                displayPrice,
                infoblock,
                ...rest
            }) => (
                <Fragment key={radioGroupName + '-' + code}>
                    <Radio
                        classes={{
                            label: disabled
                                ? classes.radioLabelDisabled
                                : classes.radioLabel,
                            root: disabled
                                ? classes.radioDisabled
                                : classes.radio
                            /*                    price: classes.price*/
                        }}
                        key={radioGroupName + '-' + code}
                        label={label}
                        value={code}
                        color={value}
                        thumb={thumb}
                        image={image}
                        price={price}
                        priceBy={price_by}
                        displayPrice={displayPrice}
                        radioGroupName={radioGroupName}
                        disabled={disabled}
                        infoBlock={infoblock}
                        {...rest}
                    />
                </Fragment>
            )
        );

        return (
            <Fragment>
                <BasicRadioGroup {...rest} fieldState={fieldState}>
                    {options}
                </BasicRadioGroup>
                <Message className={classes.message} fieldState={fieldState}>
                    {message}
                </Message>
            </Fragment>
        );
    }
}

export default compose(
    classify(defaultClasses),
    asField
)(RadioGroup);
